module.exports = __webpack_public_path__ + "static/media/logo_splash.7218b61c.png";